import { useState } from 'react'
import ClienteLayout from '../../components/ClienteLayout'
import { useAuth } from '../../lib/AuthContext'
import { WA_NUMERO, WA_TEL_DISPLAY, EMAIL_HOLA } from '../../lib/constantes'

const EMAIL = EMAIL_HOLA

const CATEGORIAS = [
  { id: 'entrega',    icon: '📦', label: 'Mi entrega',       sub: 'Día · horario · dirección' },
  { id: 'pagos',      icon: '💳', label: 'Pagos y facturas', sub: 'Tarjeta · e-factura · empresa con RUT' },
  { id: 'suscripcion',icon: '🔄', label: 'Mi suscripción',   sub: 'Pausar · cambiar · cancelar' },
  { id: 'productos',  icon: '🛒', label: 'Productos y kits', sub: 'Tienda · vecinos' },
]

const FAQ = [
  // ───── Entrega ─────
  { cat: 'entrega',     q: '¿Puedo cambiar el día de entrega?',
    a: 'Sí. Desde Mi Plan podés cambiar el día antes del corte: 16:00 hs del día anterior a la entrega. Después del corte podés elegir entre esperar al próximo día natural (gratis) o pagar $165 para que igual salga.' },
  { cat: 'entrega',     q: '¿Puedo cambiar mi dirección si me mudo?',
    a: 'Sí. En Mi Plan tocá "Mudarme". Validamos la nueva dirección en el mapa antes de confirmar. Si tu pedido del mes ya está armado, ese sale a la dirección anterior y la nueva se usa desde el próximo ciclo.' },
  { cat: 'entrega',     q: '¿Qué pasa si no estoy cuando llega?',
    a: 'Si tenés portero, lo dejamos con él. Si no, te avisamos por WhatsApp para reprogramar sin recargo.' },
  { cat: 'entrega',     q: '¿En qué barrios entregan?',
    a: 'Hoy cubrimos 10 barrios de Montevideo. Cada barrio tiene 1-2 días fijos por semana. Al armar tu suscripción te mostramos los barrios disponibles y los días de tu zona.' },
  // ───── Suscripción ─────
  { cat: 'suscripcion', q: '¿Cómo pauso mi suscripción durante 1 mes?',
    a: 'En Mi Plan tocá "Pausar 1 mes". No te cobramos ese mes y reanudamos automáticamente al siguiente.' },
  { cat: 'suscripcion', q: '¿Cómo cambio de kit?',
    a: 'En Mi Plan tocá "Cambiar mi kit" o entrá a la Tienda. El cambio aplica desde el próximo ciclo, sin recargo.' },
  { cat: 'suscripcion', q: '¿Tengo permanencia mínima?',
    a: 'No. Cancelás cuando quieras desde Mi Plan, sin costos ni letra chica.' },
  // ───── Pagos ─────
  { cat: 'pagos',       q: '¿Cuándo se cobra la suscripción?',
    a: 'Te cobramos 1 día antes de cada entrega (a las 16hs). Si tu entrega cae lunes, el cobro va el viernes anterior 16hs. Queda anclado al día de tu barrio, no al día en que te suscribiste. Si la tarjeta falla, te avisamos por WhatsApp para que la actualices antes que salga el camión.' },
  { cat: 'pagos',       q: '¿Qué medios de pago aceptan?',
    a: 'Tarjetas de crédito/débito (Visa, Mastercard, OCA, AmEx, Cabal), banca digital, Redpagos, Abitab, transferencia bancaria y cuotas sin recargo. Procesamos con MercadoPago. El cobro mensual de la suscripción es automático con tu tarjeta registrada.' },
  { cat: 'pagos',       q: '¿Puedo facturar a nombre de mi empresa con RUT?',
    a: 'Sí. En Mi Cuenta → "Datos de facturación" cargá tu empresa con RUT y razón social. Después al comprar elegís si facturamos a tu nombre (e-Ticket) o a la empresa (e-Factura).' },
  // ───── Productos / Tienda ─────
  { cat: 'productos',   q: '¿Cómo compro productos sueltos extra?',
    a: 'En la Tienda comprá los productos que quieras. Si elegís un día de tu barrio, el envío es gratis. Si elegís el mismo día que tu próxima entrega del kit, se suman a tu kit y llegan juntos en la misma bolsa 🎁. Para otros días te cobramos un envío especial fuera de ruta.' },
  { cat: 'productos',   q: '¿Cómo funciona el descuento por vecinos?',
    a: 'Si 10 vecinos de tu cuadra se suscriben a Limpack, todos ganan 5% off permanente en su suscripción (no aplica a productos sueltos de la Tienda). Mirá Vecinos para ver el progreso de tu cuadra.' },
  { cat: 'productos',   q: '¿Qué marcas usan en los kits?',
    a: 'Línea Essential: marcas con buena relación calidad/precio (Cottonmax, Brilha, Clarys, etc). Línea Premium: marcas reconocidas con aromas y rendimiento superior (Cottonmax 2-en-1, CIF, papel doble hoja). Podés ver la composición exacta de cada kit en la Tienda o al armar tu suscripción.' },
]

export default function Soporte() {
  const { user, profile } = useAuth()
  const [catActiva, setCatActiva] = useState(null)

  // Mensaje pre-armado con nombre + email para que el agente tenga contexto
  // sin tener que buscar al cliente. Auditoría WA 2026-06-04 (A1).
  function abrirWhatsApp(mensaje = '') {
    const nombre = profile?.nombre?.split(' ')[0] || ''
    const email = user?.email || ''
    const firma = nombre || email ? `\n\n— ${nombre || email}${nombre && email ? ` (${email})` : ''}` : ''
    const texto = (mensaje || 'Hola Limpack! Necesito ayuda con mi cuenta.') + firma
    window.open(`https://wa.me/${WA_NUMERO}?text=${encodeURIComponent(texto)}`, '_blank')
  }

  const faqFiltrado = catActiva ? FAQ.filter(f => f.cat === catActiva) : FAQ
  const cat = (id) => CATEGORIAS.find(c => c.id === id)

  return (
    <ClienteLayout title="Soporte">
      <div className="sp-wrap">
        <div className="sp-headline">
          <h1>¿En qué te ayudamos?</h1>
          <p>Buscá en preguntas frecuentes o escribinos directo por WhatsApp.</p>
        </div>

        <div className="sp-grid">
          {/* Hero WhatsApp */}
          <div className="sp-hero">
            <div className="sp-hero-icon">💬</div>
            <h2 className="sp-hero-h">Hablá con un humano</h2>
            <p className="sp-hero-sub">Respondemos por WhatsApp en menos de 30 minutos durante horario comercial. Más rápido que cualquier otra vía.</p>
            <button className="sp-hero-btn" onClick={() => abrirWhatsApp()}>Abrir WhatsApp →</button>
          </div>

          {/* Datos contacto */}
          <div className="sp-info">
            <h3 className="sp-info-h">📞 Datos de contacto</h3>
            <div className="sp-info-row"><b>Horario</b><span>Lun–Vie 9–18hs · Sáb 10–14hs</span></div>
            <div className="sp-info-row"><b>WhatsApp</b><a href={`https://wa.me/${WA_NUMERO}`} target="_blank" rel="noreferrer">{WA_TEL_DISPLAY}</a></div>
            <div className="sp-info-row"><b>Email</b><a href={`mailto:${EMAIL}`}>{EMAIL}</a></div>
            <div className="sp-info-row"><b>Tiempo respuesta</b><span style={{ color: '#16a34a', fontWeight: 700 }}>~25 min · WhatsApp</span></div>
          </div>
        </div>

        <h2 className="sp-section">Categorías de ayuda</h2>
        <div className="sp-cats">
          {CATEGORIAS.map(c => (
            <button
              className={`sp-cat ${catActiva === c.id ? 'active' : ''}`}
              key={c.id}
              onClick={() => setCatActiva(catActiva === c.id ? null : c.id)}
            >
              <div className="sp-cat-icon">{c.icon}</div>
              <div className="sp-cat-label">{c.label}</div>
              <div className="sp-cat-sub">{FAQ.filter(f => f.cat === c.id).length} pregunta{FAQ.filter(f => f.cat === c.id).length === 1 ? '' : 's'} · {c.sub}</div>
            </button>
          ))}
        </div>

        <h2 className="sp-section">{catActiva ? `Preguntas: ${cat(catActiva)?.label}` : 'Preguntas más consultadas'}</h2>
        <div className="sp-faq">
          {faqFiltrado.map((f, i) => (
            <details className="sp-faq-item" key={i}>
              <summary>
                <span className="sp-faq-q">{f.q}</span>
                <span className="sp-faq-tag">{cat(f.cat)?.label}</span>
              </summary>
              <p>{f.a}</p>
            </details>
          ))}
        </div>

        <div className="sp-no-encuentro">
          <span>¿No encontraste lo que buscabas?</span>
          <button className="sp-action" onClick={() => abrirWhatsApp('Hola Limpack, necesito ayuda con algo que no encuentro en el FAQ.')}>
            💬 Hablar con soporte
          </button>
        </div>
      </div>

      <style>{`
        .sp-wrap { max-width: 1320px; margin: 0 auto; padding: 16px 16px 32px }
        .sp-headline h1 { font-size: 26px; font-weight: 900; color: var(--cl-text); letter-spacing: -.02em }
        .sp-headline p { font-size: 14px; color: var(--cl-muted); margin-top: 4px; line-height: 1.5 }

        .sp-grid { display: grid; grid-template-columns: 1fr; gap: 14px; margin-top: 18px }
        .sp-hero {
          background: linear-gradient(135deg, #25d366, #128c7e); color: #fff;
          border-radius: 18px; padding: 24px;
          display: flex; flex-direction: column; gap: 8px;
        }
        .sp-hero-icon { font-size: 38px }
        .sp-hero-h { font-size: 20px; font-weight: 900; letter-spacing: -.02em }
        .sp-hero-sub { font-size: 13px; opacity: .92; line-height: 1.5 }
        .sp-hero-btn {
          margin-top: 10px; align-self: flex-start;
          background: #fff; color: #128c7e; border: 0;
          padding: 12px 22px; border-radius: 999px;
          font-weight: 800; font-size: 14px; cursor: pointer; font-family: inherit;
        }
        .sp-hero-btn:hover { transform: translateY(-1px) }

        .sp-info {
          background: linear-gradient(135deg, #ecfeff, #cffafe);
          border: 1px solid #67e8f9; border-radius: 16px; padding: 22px;
        }
        .sp-info-h { font-size: 14px; font-weight: 800; color: #155e75; margin-bottom: 10px }
        .sp-info-row {
          display: flex; gap: 10px; padding: 9px 0;
          border-bottom: 1px solid rgba(103,232,249,.4);
          font-size: 12.5px; color: #0e7490; align-items: center;
        }
        .sp-info-row:last-child { border-bottom: 0 }
        .sp-info-row b { color: #155e75; font-weight: 800; min-width: 110px; flex-shrink: 0 }
        .sp-info-row a { color: #0e7490; font-weight: 700; text-decoration: none }
        .sp-info-row a:hover { text-decoration: underline }
        .sp-info-row span { text-align: right; flex: 1 }

        .sp-section { font-size: 16px; font-weight: 900; color: var(--cl-text); margin: 28px 0 14px; letter-spacing: -.01em }

        .sp-cats { display: grid; grid-template-columns: 1fr 1fr; gap: 10px }
        .sp-cat {
          background: var(--cl-card); border: 1.5px solid var(--cl-line);
          padding: 16px; border-radius: 14px; cursor: pointer; font-family: inherit;
          display: flex; flex-direction: column; gap: 6px; text-align: left;
          transition: border-color .15s, transform .15s;
        }
        .sp-cat:hover { transform: translateY(-2px); border-color: var(--cl-teal) }
        .sp-cat.active { border-color: var(--cl-teal); background: var(--cl-teal-soft, #e6fafc) }
        .sp-cat-icon { font-size: 24px }
        .sp-cat-label { font-size: 13px; font-weight: 800; color: var(--cl-text) }
        .sp-cat-sub { font-size: 11px; color: var(--cl-muted); line-height: 1.4 }

        .sp-faq { display: flex; flex-direction: column; gap: 10px }
        .sp-faq-item { background: var(--cl-card); border: 1px solid var(--cl-line); border-radius: 12px; padding: 0 18px }
        .sp-faq-item summary { padding: 14px 0; cursor: pointer; list-style: none; display: flex; align-items: center; gap: 10px }
        .sp-faq-item summary::-webkit-details-marker { display: none }
        .sp-faq-q { flex: 1; font-size: 13.5px; font-weight: 700; color: var(--cl-text) }
        .sp-faq-tag { font-size: 10px; font-weight: 800; padding: 3px 8px; border-radius: 999px; background: var(--cl-line2); color: var(--cl-muted); text-transform: uppercase; letter-spacing: .04em; flex-shrink: 0 }
        .sp-faq-item[open] summary { border-bottom: 1px solid var(--cl-line2); padding-bottom: 14px }
        .sp-faq-item p { font-size: 13px; color: var(--cl-muted); line-height: 1.55; padding: 14px 0 16px }

        .sp-no-encuentro {
          margin-top: 24px; padding: 18px 20px;
          background: var(--cl-card); border: 1px dashed var(--cl-line);
          border-radius: 12px; display: flex; align-items: center; justify-content: space-between; gap: 14px; flex-wrap: wrap;
          font-size: 13px; color: var(--cl-muted);
        }
        .sp-action {
          background: linear-gradient(135deg, #25d366, #128c7e); color: #fff; border: 0;
          padding: 10px 18px; border-radius: 999px; font-size: 13px; font-weight: 800;
          cursor: pointer; font-family: inherit;
        }

        @media (min-width: 900px) {
          .sp-wrap { padding: 36px 44px }
          .sp-headline h1 { font-size: 32px }
          .sp-grid { grid-template-columns: 1.4fr 1fr; gap: 20px; margin-top: 24px }
          .sp-hero { padding: 32px }
          .sp-hero-h { font-size: 24px }
          .sp-hero-sub { font-size: 14px }
          .sp-section { font-size: 18px; margin: 32px 0 16px }
          .sp-cats { grid-template-columns: repeat(4, 1fr); gap: 14px }
          .sp-cat { padding: 20px }
          .sp-faq-q { font-size: 14px }
          .sp-faq-item p { font-size: 14px }
        }
      `}</style>
    </ClienteLayout>
  )
}
